import { HttpErrorResponse } from '@angular/common/http';
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { deepCopy, getDataScopeByPermission, getFacilityByPermission, getForwarderByPermission, getRoleScopeColumnMappings, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { BookingService } from '../../services/booking.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { Table } from 'primeng/table';
import { finalize } from 'rxjs/operators';
import { MenuItem } from 'primeng/api';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { TranslateService } from '@ngx-translate/core';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { LaasOption } from 'src/app/core/models/laas-option';
import { FacilityService } from 'src/app/core/services/facility.service';
import { List } from '@zxing/library/esm/customTypings';
import { PageInfo } from 'src/app/core/models/page-info';
import { SortOrder } from 'src/app/core/interface/sort-order';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';
import { SearchFormParameterGroupComponent } from 'src/app/shared/components/search-form-parameter-group/search-form-parameter-group.component';
import { forkJoin } from 'rxjs';
import { FileCategory } from 'src/app/core/constants/file-category.constant';
import { FrontlineDocumentComponent } from '../../components/frontline-document/frontline-document.component';

@Component({
  selector: 'laas-booking-search-for-forwarder',
  templateUrl: './booking-search-for-forwarder.component.html',
  styleUrls: ['./booking-search-for-forwarder.component.scss'],
})
export class BookingSearchForForwarderComponent extends SessionBaseComponent implements OnInit {

  @ViewChild('dataTable') dataTable!: Table;
  @ViewChild('detailDataTable') detailDataTable!: Table;
  @ViewChild(DataTableComponent) table!: DataTableComponent;

  readonly preferenceKey: string;
  readonly preferenceKey2: string;
  readonly permissionCode = PermissionConstants.ViewQueryBookingForForwarder;
  readonly defaultSearchParams: any;
  @ViewChild('assignDate') assignDate!: CalendarComponent;
  @ViewChild('createDt') createDt!: CalendarComponent;
  @ViewChild('parameterGroup') parameterGroupComp!: SearchFormParameterGroupComponent;
  @ViewChild('frontLineDoc') frontlineDoc!: FrontlineDocumentComponent;

  currentLang: string = this.laasSetting.language;
  bookingNo: string;

  searchParams: any;
  columns: any[];
  isLoading: boolean;
  facilityOptions: any[] = [];
  bookingForwarderList: any[];
  deliveryCategoryList: any[];
  bookingTypeList: any[];
  bookingStatusOptions: any[];
  chargeStatusList: any[];
  carSeqList: any[];
  letterOrgIdList: any[];
  orgIdList: any[];
  billCorpList: any[];
  shipCorpList: any[];
  shipTermOptions: LaasOption[];
  areaList: any[];
  DOStatusOptions: any[];
  documentTypeOptions: any[];
  priorityOptions: any[];
  selectedBookings: any[];
  isFeeCalculationOptions: any[];
  shipMethodOptions: any[];

  isSearchFormOpen: boolean;
  searchResults: any[];
  detailColumns: any[];
  bookingDetails: any[];

  isShowScanDOModal: boolean;
  isShowSearchDOModal: boolean;
  isShowRtnWhRemarkModal: boolean;
  isShowRtnDeliveryRemarkModal: boolean;
  isShowUrgentRemarkModal: boolean;
  importedDOs: any[];

  importDocData: any[];
  isShowCertificateModal: boolean;
  isShowReturnTmsModal: boolean;
  isShowBillingViewerModal: boolean;

  rowData: any;

  searchForm: FormGroup;
  itemMenus: MenuItem[];
  mainItemMenus: MenuItem[];

  // file Management
  showDoFile: boolean;
  showDoPodFile: boolean;
  bookingNoFile: string;
  bookingInfo: any;

  selectedDORows: any[];

  tmsData: any;

  billCorpOptions: any[];
  isPickupFlagList: any[];

  toCountryOptions: any[];
  toCityOptions: any[];
  assignmentDistrictIdOptions: any[];
  awbAddressOptions: any[];
  noPickingDoOptions: any[];
  bookingDetailStatusOptions: any[];

  // translate label
  transFile: any;
  transOriginalDoc: any;
  transDownload: any;
  transUploadAttach: any;
  transUpload: any;
  transUploadPOD: any;
  costReview = '';

  transFrontLineDocBtnLabel: any;
  frontLIneDocReferenceKeyList: string[] = [];
  fileCategoryForTaskDoc: FileCategory = FileCategory.FrontLine;
  isShowTaskDocManagement: boolean = false;
  uploadFileType: string = '';

  pageInfo: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };

  sortOrder: SortOrder = {
    property: "bookingNo",
    direction: -1
  };

  constructor(
    injector: Injector,
    private bookingService: BookingService,
    private facilityService: FacilityService,
    private commonDataService: CommonDataService,
    private dropdownOptionService: DropdownOptionsService,
    private formBuilder: FormBuilder,
    private translate: TranslateService
  ) {
    super(injector);
    this.preferenceKey = UserPreferenceConstants.BookingSearchForForwarder;
    this.preferenceKey2 = UserPreferenceConstants.BookingSearchForForwarderDetail;

    this.defaultSearchParams = {
      facilityList: [],
      bookingForwarder: [],
      deliveryCategory: null,
      bookingType: null,
      bookingNoList: [],
      bookingStatus: [],
      carTrips: [],
      consigneeKey: [],
      chargeStatus: null,
      letterOrgId: [],
      orgId: [],
      billCorp: [],
      doNo: [],
      invoiceNo: [],
      createStartDt: null,
      createEndDt: null,
      assignStartDate: null,
      assignEndDate: null,
      carSeq: null,
      area: null,
      createUserList: [],
      hawbs: [],
      mawbs: [],
      isFeeCaculation: null,
      whNo: [],
      shipCorp: null,
      expressTerm: [],
      shippingMethodList: [],
      carType: null
    };

    this.columns = this.tableTranslation();
    this.detailColumns = this.detailTableTranslation();

    this.searchParams = deepCopy(this.defaultSearchParams);

    this.searchForm = this.formBuilder.group({
      facilityList: this.defaultSearchParams.facilityList,
      bookingForwarder: [],
      deliveryCategory: null,
      bookingType: null,
      bookingNoList: [],
      bookingStatus: [],
      carTrips: [],
      consigneeKey: [],
      chargeStatus: null,
      letterOrgId: [],
      orgId: [],
      billCorp: [],
      doNo: [],
      invoiceNo: [],
      createStartDt: null,
      createEndDt: null,
      assignStartDate: null,
      assignEndDate: null,
      carSeq: null,
      area: null,
      createUserList: [],
      hawbs: [],
      mawbs: [],
      isFeeCaculation: null,
      whNo: [],
      shipCorp: null,
      expressTerm: [],
      shippingMethodList: [],
      carType: null
    });

    this.isLoading = false;
    this.bookingStatusOptions = [];
    this.DOStatusOptions = [];
    this.bookingForwarderList = [];
    this.deliveryCategoryList = [];
    this.bookingTypeList = [];
    this.selectedBookings = [];
    this.chargeStatusList = [];
    this.carSeqList = [];
    this.letterOrgIdList = [];
    this.orgIdList = [];
    this.billCorpList = [];
    this.shipCorpList = [];
    this.shipTermOptions = [];
    this.areaList = [];
    this.isFeeCalculationOptions = [];
    this.shipMethodOptions = [];
    this.priorityOptions = [];
    this.documentTypeOptions = [];
    this.isSearchFormOpen = true;
    this.searchResults = [];
    this.isShowScanDOModal = false;
    this.isShowSearchDOModal = false;
    this.isShowRtnWhRemarkModal = false;
    this.isShowRtnDeliveryRemarkModal = false;
    this.isShowUrgentRemarkModal = false;
    this.isShowCertificateModal = false;
    this.isShowReturnTmsModal = false;
    this.isShowBillingViewerModal = false;
    this.importedDOs = [];
    this.bookingNo = '';
    this.bookingDetails = [];
    this.importDocData = [];

    // translate
    this.mainItemMenus = [
      {
        label: '',
        items: [],
      },
    ];
    this.translate.onLangChange.subscribe((e: Event) => {
      this.translationLabel();
      this.tableTranslation();
      this.detailTableTranslation();
    });
    this.translationLabel();
    this.tableTranslation();
    this.detailTableTranslation();

    this.itemMenus = [];

    this.billCorpOptions = [];

    this.selectedDORows = [];
    this.tmsData = [];

    // file management
    this.showDoFile = false;
    this.showDoPodFile = false;
    this.bookingNoFile = '';

    this.toCountryOptions = [];
    this.toCityOptions = [];
    this.assignmentDistrictIdOptions = [];
    this.awbAddressOptions = [];
    this.bookingDetailStatusOptions = [];

    this.noPickingDoOptions = [
      { label: '揀貨', value: '0' },
      { label: '不揀貨', value: '1' },
    ];

    this.isPickupFlagList = [
      { value: 0, label: '揀貨' },
      { value: 1, label: '不揀貨' },
    ];
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.searchParams.facilityList = this.userProfile.userType === UserType.SuperAdmin.toString() || this.userProfile.userType === UserType.Tenant.toString() ? null : [this.laasSetting.facility];
    this.defaultSearchParams.facilityList = deepCopy(this.searchParams.facilityList);

    const routeData = this.routeStateService.getCurrent()?.data;
    if (!isNullOrEmpty(routeData)) {
      this.searchParams.bookingNoList = routeData.bookingNoList;
      if (routeData.errMsgs.length > 0) {
        const msgs = routeData.errMsgs.reduce(
          (str: string, msg: string, idx: number) => {
            str += `${idx + 1}. ${msg}\n`;
            return str;
          },
          ''
        );
        this.toastService.error(msgs);
      }
    }

    this.dropdownOptionService.getFacilityOptions().subscribe({
      next: (options: any[]) => {
        this.facilityOptions = options.filter(x => {
          return this.userProfile.userType == UserType.SuperAdmin.toString() ||
            getFacilityByPermission(this.userProfile, this.permissionCode).includes(null) ||
            getFacilityByPermission(this.userProfile, this.permissionCode).includes(x.optionCode)
        })
        .map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    this.dropdownOptionService.getForwarderOptions().subscribe({
      next: (result) => {
        this.bookingForwarderList = result.filter((x: any) => {
          return ( this.userProfile.userType == UserType.SuperAdmin.toString() ||
            this.userProfile.userType == UserType.Shipping.toString() ||
            getForwarderByPermission(this.userProfile, this.permissionCode).includes(x.optionCode));
        }).map((x: any) => ({ label: x.optionDesc, value: x.optionCode }));
      },
    });

    this.dropdownOptionService.getCarSeqOptions().subscribe({
      next: (result) => {
        this.carSeqList = result;
      },
    });

    this.dropdownOptionService.getLetterOrgOptions().subscribe({
      next: (result: any[]) => {
        this.letterOrgIdList =
          this.orgIdList =
          this.shipCorpList =
            result.map((x) => ({
              label: x.legalEntityOUName,
              value: x.legalEntityOUCode,
            }));
        this.billCorpList = result
          .filter((x) => x.billOUCode !== null)
          .reduce((options, item) => {
            if (
              options.findIndex((x: any) => x.value === item.billOUCode) < 0
            ) {
              options.push({ label: item.billOUName, value: item.billOUCode });
            }
            return options;
          }, [])
          .sort((a: any, b: any) => {
            return a.value > b.value ? 1 : -1;
          });
      },
    });

    this.dropdownOptionService.getIncoTermOptions().subscribe({
      next: (options: any[]) => {
        this.shipTermOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getAreaOptions().subscribe({
      next: (options: any[]) => {
        this.areaList = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getDeliveryTypeOptions(false).subscribe({
      next: (options: any[]) => {
        this.deliveryCategoryList = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getBookingTypeOptions().subscribe({
      next: (options: any[]) => {
        this.bookingTypeList = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getBookingStatusOptions().subscribe({
      next: (options: any[]) => {
        this.bookingStatusOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getToCountryOptions().subscribe({
      next: (options: any[]) => {
        this.toCountryOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getAllCityOptions().subscribe({
      next: (options: any[]) => {
        this.toCityOptions = options.map((x) => ({
          label: x.name,
          value: x.seqNo.toString(),
        }));
      },
    });

    this.dropdownOptionService.getAreaOptions().subscribe({
      next: (options: any[]) => {
        this.assignmentDistrictIdOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getPickupLocationOptions().subscribe({
      next: (options: any[]) => {
        this.awbAddressOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getDOStatusOptions().subscribe({
      next: (options: any[]) => {
        this.DOStatusOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getPriorityOptions().subscribe({
      next: (options: any[]) => {
        this.priorityOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.commonDataService
      .getCodeConverter(
        this.laasSetting.language,
        'DropdownList',
        'BookingSearchForForwarderChargesStatus'
      )
      .subscribe({
        next: (options: any[]) => {
          this.chargeStatusList = options.map((x) => ({
            label: x.codeKey + '-' + x.codeDesc,
            value: x.codeKey,
          }));
        },
      });

    this.facilityService.getShipMethodOptions().subscribe({
      next: (options: any[]) => {
        this.shipMethodOptions = options.map((x) => ({
          label: `${x.optionCode}-${x.optionDesc}`,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService
      .getDocumentTypeOptionsByCategories([2, 3])
      .subscribe({
        next: (options: any[]) => {
          this.mainItemMenus = [
            {
              label: '',
              items: [],
            },
          ];

          if (
            !this.permissionCodes.includes(
              PermissionConstants.ViewShipImportConfirmReportForBooking
            )
          ) {
            const index = options.findIndex(
              (x) => x.optionCode === 'ShipImportConfirmForBooking'
            );
            options.splice(index, 1);
          }

          this.mainItemMenus[0].label = this.transFile;
          const menuItems = options.map((x) => {
            const menu = {
              label: x.optionDesc,
              state: { docType: x.optionCode },
              command: (event: any) => {
                const docType = event.item.state.docType;
                let bookings = this.selectedBookings.map((x: any) => {
                  return x.bookingNo;
                });
                let remark = '';
                this.downloadShippingDocuments(
                  docType,
                  'Booking',
                  bookings,
                  remark
                );
              },
            };
            return menu;
          });

          menuItems.unshift(
            {
              label: this.transFrontLineDocBtnLabel,
              state: {
                docType: null,
              },
              command: (event: any) => {
                if (this.selectedBookings.length == 0) {
                  return;
                }
                this.frontlineDocBtnClick();
              },
            }
          );

          if (this.mainItemMenus.length > 0) {
            this.mainItemMenus[0].items = menuItems;
          }
        },
      });

    this.dropdownOptionService
      .getDocumentTypeOptionsByCategories([1, 3])
      .subscribe({
        next: (options: any[]) => {
          this.itemMenus = [
            {
              label: this.transOriginalDoc,
              items: [
                {
                  label: this.transDownload,
                  command: (event: any) => {
                    const rowData = this.table.selectedRow;
                    if (!rowData) {
                      return;
                    }
                    this.certificateBtnClick(event, rowData);
                  },
                },
              ],
            },
            {
              label: this.transUploadAttach,
              items: [
                {
                  label: this.transUpload,
                  command: (event: any) => {
                    const rowData = this.table.selectedRow;
                    if (!rowData) {
                      return;
                    }
                    this.bookingNoFile = rowData.bookingNo;
                    this.showDoFile = true;
                  },
                },
                {
                  label: this.transUploadPOD,
                  command: (event: any) => {
                    const rowData = this.table.selectedRow;
                    if (!rowData) {
                      return;
                    }
                    this.bookingNoFile = rowData.bookingNo;
                    this.showDoPodFile = true;
                  },
                },
              ],
            },
            {
              label: this.costReview,
              command: (event: any) => {
                const rowData = this.table.selectedRow;
                if (!rowData) {
                  return;
                }
                this.bookingInfo = rowData;
                this.bookingNoFile = rowData.bookingNo;
                this.isShowBillingViewerModal = true;
              },
              visible: this.permissionCodes.includes(
                PermissionConstants.BtnExpenseView
              ),
            },
          ];
          const menuItems = options.map((x) => {
            const menu = {
              label: x.optionDesc,
              state: { docType: x.optionCode },
              command: (event: any) => {
                const rowData = this.table.selectedRow;
                if (!rowData) {
                  return;
                }
                const docType = event.item.state.docType;
                let doNos = rowData.doNos.map((x: any) => {
                  return x.doNo;
                });
                let remark = '';
                this.downloadShippingDocuments(
                  docType,
                  'DeliveryOrder',
                  doNos,
                  remark
                );
              },
            };
            return menu;
          });

          let rootMenu: MenuItem = {
            label: this.transFile,
            items: menuItems,
          };
          this.itemMenus.push(rootMenu);
        },
      });

    this.dropdownOptionService
      .getLetterOrgOptions(this.laasSetting.facility)
      .subscribe({
        next: (options: any[]) => {
          this.billCorpOptions = options.map((x) => ({
            label: x.billOUName,
            value: x.billOUCode,
          }));
        },
      });

    //rbac to maintain this page
    let canInPage = this.permissionCodes.includes(this.permissionCode);
    if (!canInPage) {
      //go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }

    this.commonDataService
      .getCodeConverter(
        this.laasSetting.language,
        'DropdownList',
        'IsFeeCalculation'
      )
      .subscribe({
        next: (options: any[]) => {
          this.isFeeCalculationOptions = options.map((x) => ({
            label: x.codeDesc,
            value: x.codeKey,
          }));
        },
      });
  }

  translationLabel() {
    //下載文件
    this.transFile = this.translateService.instant(
      'BookingSearch.MainTable.Button.DownloadFile'
    );
    //原始憑證
    this.transOriginalDoc = this.translateService.instant(
      'BookingSearch.SubTable.Button.OriginalDoc'
    );
    //下載
    this.transDownload = this.translateService.instant(
      'BookingSearch.SubTable.Button.Download'
    );
    //附件上傳
    this.transUploadAttach = this.translateService.instant(
      'BookingSearch.SubTable.Button.UploadAttach'
    );
    //上傳
    this.transUpload = this.translateService.instant(
      'BookingSearch.SubTable.Button.Upload'
    );
    //客戶簽收單上傳
    this.transUploadPOD = this.translateService.instant(
      'BookingSearch.SubTable.Button.UploadPOD'
    );
    //
    this.costReview = this.translateService.instant(
      'BookingSearch.SubTable.Button.CostReview'
    );
    this.transFrontLineDocBtnLabel = this.translateService.instant(
      'ShippingStatus.Button.FrontLineDoc'
    );
  }

  // translate table
  tableTranslation(): any[] {
    let fields: string[];
    let jsons: string[];
    let tmpcolumn: any[] = [];

    fields = [
      'facility',
      'bookingNo',
      'bookingStatus',
      'bookingType',
      'forwarderName',
      'letterHeadOrgName',
      'billCorp',
      'consigneeKey',
      'consigneeCompany',
      'shipTerm',
      'toCountry',
      'toCity',
      'assignmentDistrictId',
      'carTrip',
      'awbAddress',
      'assignDate',
      'carSeq',
      'updatedTotalCaseCnt',
      'totalNetWeight',
      'updatedTotalGrosswgt',
      'updatedTotalVolumeWeight',
      'estimatedCost',
      'expressBill',
      'isPickupFlag',
      'createUser',
      'createDt',
      'isFeeCaculation',
      'expressTerm',
      'shipCorp',
      'shippingMethod',
      'carType'
    ];

    jsons = [
      'BookingSearch.MainTable.Column.Facility',
      'BookingSearch.MainTable.Column.BookingNum',
      'BookingSearch.MainTable.Column.BookingStatus',
      'BookingSearch.MainTable.Column.Type',
      'BookingSearch.MainTable.Column.Forwarder',
      'BookingSearch.MainTable.Column.Company',
      'BookingSearch.MainTable.Column.BillComp',
      'BookingSearch.MainTable.Column.CustomerCode',
      'BookingSearch.MainTable.Column.CustomerName',
      'BookingSearch.MainTable.Column.TradeTerm',
      'BookingSearch.MainTable.Column.DestiCountry',
      'BookingSearch.MainTable.Column.DestiCity',
      'BookingSearch.MainTable.Column.LocalSection',
      'BookingSearch.MainTable.Column.CarTripNum',
      'BookingSearch.MainTable.Column.PickUpLocate',
      'BookingSearch.MainTable.Column.AssignDate',
      'BookingSearch.MainTable.Column.DepartureTime',
      'BookingSearch.MainTable.Column.TotalCartonCnt',
      'BookingSearch.MainTable.Column.TotalCartonCnt',
      'BookingSearch.MainTable.Column.TotalNetWeight',
      'BookingSearch.MainTable.Column.TotalDim',
      'BookingSearch.MainTable.Column.EstimateCharges',
      'BookingSearch.MainTable.Column.HAWB',
      'BookingSearch.MainTable.Column.IsPickupFlag',
      'BookingSearch.MainTable.Column.Creator',
      'BookingSearch.MainTable.Column.CreationaTime',
      'BookingSearch.MainTable.Column.FeeRemarks',
      'BookingSearch.MainTable.Column.CourierDeliveryCondition',
      'BookingSearch.MainTable.Column.ShipCorp',
      'BookingSearch.MainTable.Column.ShippingMethod',
      'BookingPreview.Form.VehicleType',
    ];

    for (let i = 0; i < fields.length; i++) {
      this.translateService.get(jsons[i]).subscribe((translation: string) => {
        // dataType: 'date'
        if (i == 15 || i == 21) {
          tmpcolumn[i] = {
            field: fields[i],
            header: translation,
            dataType: 'date',
            sort: true,
          };
        } else {
          tmpcolumn[i] = { field: fields[i], header: translation, sort: true };
        }
      });
    }
    return tmpcolumn;
  }

  detailTableTranslation(): any[] {
    let fields: string[];
    let jsons: string[];
    let tmpcolumn: any[] = [];

    fields = [
      'facility',
      'doNo',
      'invoiceNo',
      'consigneeKey',
      'consigneeCompany',
      'shipNotes',
      'cartonCnt',
      'totalGrossWeight',
      'totalNetWeight',
      'volumeWeight',
      'doStatus',
      'status',
      'orgName',
      'shipCorpName',
      'letterHeadOrgName',
      'csr',
      'dept',
      'bookingCount',
      'priority',
      'urgentFlag',
      'loadingDate',
      'loadingBy',
      'leaveDate',
      'leaveBy',
      'arrivalBy',
      'tmsUrl',
      'estimatedArrivalDt',
      'fixedEstimatedArrivalDt',
      'arrivalDt',
      'createUser',
      'createDt',
      'updateUser',
      'updateDt',
      'rebookingRemark',
      'noPickingDo',
      'whNo',
    ];

    jsons = [
      'BookingSearch.SubTable.Column.Facility',
      'BookingSearch.SubTable.Column.DONum',
      'BookingSearch.SubTable.Column.DOInvoiceNum',
      'BookingSearch.SubTable.Column.CustomerCode',
      'BookingSearch.SubTable.Column.CustomerName',
      'BookingSearch.SubTable.Column.Remarks',
      'BookingSearch.SubTable.Column.CartonCnt',
      'BookingSearch.SubTable.Column.GrossWeight',
      'BookingSearch.SubTable.Column.NetWeight',
      'BookingSearch.SubTable.Column.Volume',
      'BookingSearch.SubTable.Column.DOProcessStatus',
      'BookingSearch.SubTable.Column.BookingProcessStatus',
      'BookingSearch.SubTable.Column.LoadOrderComp',
      'BookingSearch.SubTable.Column.ShipOutComp',
      'BookingSearch.SubTable.Column.CompLetterHead',
      'BookingSearch.SubTable.Column.CSR',
      'BookingSearch.SubTable.Column.Department',
      'BookingSearch.SubTable.Column.BookingTimes',
      'BookingSearch.SubTable.Column.DOUrgent',
      'BookingSearch.SubTable.Column.DeliveryUrgentDO',
      'BookingSearch.SubTable.Column.LoadAssignTime',
      'BookingSearch.SubTable.Column.LoadAssignStaffID',
      'BookingSearch.SubTable.Column.LeaveDate',
      'BookingSearch.SubTable.Column.LeaveBy',
      'BookingSearch.SubTable.Column.DeliveredStaffID',
      'BookingSearch.SubTable.Column.TMSURL',
      'BookingSearch.SubTable.Column.ETD',
      'BookingSearch.SubTable.Column.RevisedETD',
      'BookingSearch.SubTable.Column.ActualArrivalTime',
      'BookingSearch.SubTable.Column.CreateBy',
      'BookingSearch.SubTable.Column.CreationTime',
      'BookingSearch.SubTable.Column.UpdateBy',
      'BookingSearch.SubTable.Column.UpdateTime',
      'BookingSearch.SubTable.Column.ReasonMultiDeliver',
      'BookingSearch.SubTable.Column.DONoPicking',
      'BookingSearch.SubTable.Column.WhNo',
    ];

    for (let i = 0; i < fields.length; i++) {
      this.translateService.get(jsons[i]).subscribe((translation: string) => {
        //dataType: 'date'
        if (
          i == 20 ||
          i == 22 ||
          i == 26 ||
          i == 27 ||
          i == 28 ||
          i == 30 ||
          i == 32
        ) {
          tmpcolumn[i] = {
            field: fields[i],
            header: translation,
            dataType: 'date',
          };
        } else {
          tmpcolumn[i] = { field: fields[i], header: translation, sort: true };
        }
      });
    }
    return tmpcolumn;
  }

  bookingAccordionTabOpen(): void {
    this.isSearchFormOpen = true;
  }

  tableSort(event: any): void {
    this.sortOrder = { property: event.field, direction: event.order };
    this.table.setCurrentPage(0);
    this.searchBooking();
  }

  tablePageChange(event: any) {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.searchBooking();
  }

  searchBtnClick(): void {
    this.isSearchFormOpen = false;
    this.selectedBookings.length = 0;
    this.pageInfo.pageIndex = 0;
    this.table.setCurrentPage(0);
    this.searchBooking();
  }

  // search
  searchBooking(): void {
    const params = deepCopy(this.searchParams);
    params.dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);
    params.roleScopeColumnMappings = getRoleScopeColumnMappings(this.userProfile, this.permissionCode);
    params.orgIds = this.searchParams.orgId;
    params.bookingForwarders = this.searchParams.bookingForwarder;
    params.bookingNos = this.searchParams.bookingNoList;
    params.carTrips = this.searchParams.carTrips;
    params.hawbs = this.searchParams.hawbs;
    params.consigneeKeys = this.searchParams.consigneeKey;
    params.letterOrgIds = this.searchParams.letterOrgId;
    params.billCorps = this.searchParams.billCorp;
    params.shipCorps = this.searchParams.shipCorp;
    params.doNos = this.searchParams.doNo;
    params.whNos = this.searchParams.whNo;
    params.invoiceNos = this.searchParams.invoiceNo;
    params.shippingMethods = this.searchParams.shippingMethodList;
    params.createStartDt = isNullOrEmpty(params.createStartDt) ? null : new Date(params.createStartDt).toISOString();
    params.createEndDt = isNullOrEmpty(params.createEndDt) ? null : new Date(params.createEndDt).toISOString();
    params.assignStartDate = isNullOrEmpty(params.assignStartDate) ? null : new Date(params.assignStartDate).toISOString();
    params.assignEndDate = isNullOrEmpty(params.assignEndDate) ? null : new Date(params.assignEndDate).toISOString();
    params.pageIndex = this.pageInfo.pageIndex;
    params.pageSize = this.pageInfo.pageSize;
    params.sortOrder = this.sortOrder;

    this.isLoading = true;
    this.bookingService.findBookingForForwarder(params)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: (response) => {
          this.searchResults = response.content;
          response.content.forEach((x: any) => {
            x.bookingDetails = [];
          });
          // Change page Info
          this.pageInfo.totalRecords = response.totalElements;
          this.pageInfo.totalPages = this.pageInfo.totalRecords / this.pageInfo.pageSize;
          this.table.setPageInfo(this.pageInfo.totalRecords);
        },
        error: (err: HttpErrorResponse) => {
          this.pageInfo.totalRecords = 0;
          this.pageInfo.totalPages = 0;
          this.table.setPageInfo(this.pageInfo.totalRecords);
          this.toastErrorMessage(err.error);
        },
      });
  }

  bookingNoLinkClick(event: any, rowData: any): void {
    this.routeStateService.navigateTo(
      '/TransportOperation/BookingSearchForForwarderHeaderDetail',
      rowData,
      true
    );
  }

  scanDOBtnClick(event: any, rowData: any): void {
    this.bookingNo = rowData.bookingNo;
    this.rowData = rowData;
    this.isShowScanDOModal = true;
  }

  searchDOBtnClick(event: any, rowData: any): void {
    this.bookingNo = rowData.bookingNo;
    this.rowData = rowData;
    this.isShowSearchDOModal = true;
  }

  rtnWarehouseBtnClick(event: any, rowData: any): void {
    this.bookingNo = rowData.bookingNo;
    this.rowData = rowData;
    this.isShowRtnWhRemarkModal = true;
  }

  rtnDeliveryBtnClick(event: any, rowData: any): void {
    this.bookingNo = rowData.bookingNo;
    this.rowData = rowData;
    this.isShowRtnDeliveryRemarkModal = true;
  }

  urgentBtnClick(event: any, rowData: any): void {
    this.bookingNo = rowData.bookingNo;
    this.rowData = rowData;
    this.isShowUrgentRemarkModal = true;
  }

  remarkSaved(event: any, booking: any): void {
    this.searchDetailClick({ rowData: booking, expanded: false });
    this.translateService.get('Common.Message.SuccessSave').subscribe({
      next: (msg) => {
        this.toastService.success(msg);
      },
    });
  }

  DOScanModalImported(event: any): void {
    const DONos = event.data.map((x: any) => x.doNo);
    this.importedDOs = [];
    this.isShowScanDOModal = false;

    if (this.rowData.bookingType === 'B') {
      const validDOs = event.data;
      this.importedDOs = [...this.importedDOs, ...validDOs];
      if (validDOs.length > 0) {
        this.saveDoNoIntoBooking(this.bookingNo, validDOs);
      }
      return;
    }

    this.bookingService
      .checkBookingDetailsInserable(this.bookingNo, DONos)
      .subscribe({
        next: (result) => {
          const invalidDONos: string[] = result.validationList
            .filter((x: any) => !x.validationFlag)
            .map((x: any) => x.doNo);
          const validDONos: string[] = result.validationList
            .filter((x: any) => x.validationFlag)
            .map((x: any) => x.doNo);
          const validDOs = event.data.filter((x: any) =>
            validDONos.includes(x.doNo)
          );
          this.importedDOs = [...this.importedDOs, ...validDOs];
          if (validDOs.length > 0) {
            this.saveDoNoIntoBooking(this.bookingNo, validDOs);
          }
          if (invalidDONos.length > 0) {
            const errMsg = invalidDONos.reduce((msg, DONo, idx) => {
              msg += `${idx + 1}. ${DONo}\n`;
              return msg;
            }, '以下 DO 無法新增至 Booking：\n');
            this.toastService.error(errMsg);
          }
        },
      });
  }

  DOSearchModalImported(event: any): void {
    const DONos = event.data.selected.map((x: any) => x.doNo);
    this.importedDOs = [];
    this.isShowSearchDOModal = false;
    const eventData: { selected: any[]; deleted: any[] } = event.data;
    this.bookingService
      .checkBookingDetailsInserable(this.bookingNo, DONos)
      .subscribe({
        next: (result) => {
          const invalidDONos: string[] = result.validationList
            .filter((x: any) => !x.validationFlag)
            .map((x: any) => x.doNo);
          const validDONos: string[] = result.validationList
            .filter((x: any) => x.validationFlag)
            .map((x: any) => x.doNo);
          const validDOs = eventData.selected.filter((x: any) =>
            validDONos.includes(x.doNo)
          );
          this.importedDOs = [
            ...this.importedDOs
              .filter(
                (x) =>
                  eventData.selected.findIndex((y) => y.doNo === x.doNo) === -1
              )
              .filter(
                (x) =>
                  eventData.deleted.findIndex((y) => y.doNo === x.doNo) === -1
              ),
            ...validDOs,
          ];
          if (validDOs.length > 0) {
            this.saveDoNoIntoBooking(this.bookingNo, validDOs);
          }
          if (invalidDONos.length > 0) {
            const errMsg = invalidDONos.reduce((msg, DONo, idx) => {
              msg += `${idx + 1}. ${DONo}\n`;
              return msg;
            }, '以下 DO 無法新增至 Booking：\n');
            this.toastService.error(errMsg);
          }
        },
      });
  }

  saveDoNoIntoBooking(bookingNo: string, importedDOs: any[]): void {
    this.isLoading = true;
    this.bookingService
      .saveDoNoIntoBooking(
        this.laasSetting.facility,
        importedDOs,
        this.userProfile.userName,
        bookingNo
      )
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (result) => {
          this.rowData.bookingDetails = result.searchBookingDetailList;
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err.error);
        },
      });
  }

  searchDetailClick(event: any): void {
    const rowData = event.rowData;
    const isClosed = event.expanded;

    if (isClosed) {
      return;
    }

    this.bookingNo = rowData.bookingNo;
    this.bookingService
      .getBookingDetail(rowData.facility, rowData.bookingNo)
      .subscribe({
        next: (result) => {
          this.searchResults.forEach((x: any) => {
            x.doNos = [];
          });

          rowData.bookingDetails = [...result.searchBookingDetailList].map(
            (x: any) => {
              x.doNos = [];
              return x;
            }
          );
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err.error);
        },
      });
  }

  resetBtnClick(event: any): void {
    this.createDt.ngOnInit();
    this.assignDate.ngOnInit();
    this.searchForm.reset({
      facilityList: this.defaultSearchParams.facilityList
    });
    this.parameterGroupComp.clearSelection();
    this.searchParams.createStartDt = null;
    this.searchParams.createEndDt = null;
    this.searchParams.assignStartDate = null;
    this.searchParams.assignEndDate = null;
  }

  /**
   * chips add event.
   *
   * @param event p-chips onAdd event.
   * @param param
   */
  chipsAdd(event: any,param:string): void {
    const value: string = event.value;
    const parsedValues: string[] = value
      .split('\r\n')
      .filter((x) => isNullOrEmpty(x) === false && x !== '\r\n');
    this.searchParams[param].splice(this.searchParams[param].indexOf(0));
    this.searchParams[param] = this.searchParams[param].concat(parsedValues);
  }

  parameterGroupChange(event: any): void {
    if (isNullOrEmpty(event)) {
      this.searchParams = deepCopy(this.defaultSearchParams);
      this.searchForm.patchValue(this.searchParams);
      this.createDt.ngOnInit();
      this.assignDate.ngOnInit();
    } else {
      this.searchParams = { ...event.data };
      this.searchForm.patchValue(this.searchParams, { emitEvent: false });
      const cStart = this.searchParams.createStartDt ? new Date(this.searchParams.createStartDt) : null;
      const cEnd = this.searchParams.createEndDt ? new Date(this.searchParams.createEndDt) : null;
      this.createDt.syncUIFromOutside([cStart, cEnd]);
      const aStart = this.searchParams.assignStartDate ? new Date(this.searchParams.assignStartDate) : null;
      const aEnd = this.searchParams.assignEndDate ? new Date(this.searchParams.assignEndDate) : null;
      this.assignDate.syncUIFromOutside([aStart, aEnd]);
    }
    this.searchForm.patchValue({ facilityList: this.searchParams.facilityList });
  }

  unBookmarked(event: any): void {
    this.searchParams = deepCopy(this.defaultSearchParams);
    this.createDt.ngOnInit();
    this.assignDate.ngOnInit();
    this.searchForm.patchValue({ facilityList: this.searchParams.facilityList });
  }

  displayMessageArray(msgStr: string): string {
    if (isNullOrEmpty(msgStr)) {
      return '';
    }
    const array = msgStr.split(',').filter((x) => isNullOrEmpty(x) === false);
    if (array.length === 0) {
      return '';
    }
    const context = array.map((x, idx) => `${idx + 1}. ${x}`).join('\n');
    return context;
  }

  certificateBtnClick(event: any, rowData: any): void {
    this.bookingNo = rowData.bookingNo;
    this.rowData = rowData;
    this.bookingService
      .getImportDocData(this.rowData.facility, this.rowData.bookingNo)
      .subscribe({
        next: importDocDataList => {
          console.log("getImportDocData:", importDocDataList);
          if (importDocDataList != null) {
            // for dataKey
            importDocDataList.forEach((col:any,index:number) => col.index = index);
            this.importDocData = importDocDataList;
            this.isShowCertificateModal = true;
          } else {
            //查無資料
            this.translateService.get('BoookingSearch.Success.NoDataFound')
              .subscribe({
                next: result => {
                  this.toastService.warn(result);
                }
              });
          }
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err.error);
        },
      });
  }

  certificateModal(event: any): void {
    this.importedDOs = [];
    this.isShowCertificateModal = false;
  }

  formatTableTitle(booking: any): string {
    return `BookingDetail - ${booking.bookingNo}`;
  }

  private downloadShippingDocuments(
    docType: string,
    referenceType: string,
    bookingNos: string[],
    remark: string
  ): void {
    this.bookingService
      .downloadShippingDocuments(
        docType,
        referenceType,
        bookingNos,
        this.userProfile.loginAccount,
        false,
        remark
      )
      .subscribe({
        next: (results: any[]) => {
          if (
            results.length === 0 ||
            results[0].attachFileDetailBeans.length === 0 ||
            isNullOrEmpty(results[0].attachFileDetailBeans[0].file) ||
            isNullOrEmpty(results[0].attachFileDetailBeans[0].fileName)
          ) {
            this.toastService.info('無檔案可下載');
            return;
          }
          const fileInfo = results[0].attachFileDetailBeans[0];
          const byteStr = atob(fileInfo.file);
          const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteStr.length);
          const int8Array: Uint8Array = new Uint8Array(arrayBuffer);
          for (let i = 0; i < byteStr.length; i++) {
            int8Array[i] = byteStr.charCodeAt(i);
          }
          const data: Blob = new Blob([int8Array], { type: 'application/pdf' });
          const url = URL.createObjectURL(data);
          const linkEle = document.createElement('a');
          linkEle.href = url;
          linkEle.download = fileInfo.fileName;
          linkEle.click();
          URL.revokeObjectURL(url);
          linkEle.remove();
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err);
        },
      });
  }

  closeFile(display: boolean): void {
    this.showDoFile = display;
    this.showDoPodFile = display;
  }

  closeBilling(display: boolean): void {
    this.isShowBillingViewerModal = display;
  }

  showBatchUpdateBtn(): boolean {
    return this.permissionCodes.includes(
      PermissionConstants.BatchUpdatedDeclarationBookingInfo
    );
  }

  gotoBatchUpdate(event: any): void {
    this.routeStateService.navigateTo('/TransportOperation/BatchUpdateBooking');
  }

  dateOnChange(date: any,type:string) {
    switch(type){
      case "createDt" :
        this.searchParams.createStartDt = date.startDate;
        this.searchParams.createEndDt = date.endDate;
        break;
      case "assignDate":
        this.searchParams.assignStartDate = date.startDate;
        this.searchParams.assignEndDate = date.endDate;
        break;
    }
  }

 showDateOnChange(event: any) {
    if (!isNullOrEmpty(event.data.createStartDt)) {
      const createStart = new Date(event.data.createStartDt);
      if (isNullOrEmpty(event.data.createEndDt)) {
        this.createDt.changeSelectMode('Start');
        //change mode 完會延遲200ms clear date
        setTimeout(() => {
          this.createDt.changeShowDate(createStart);
        }, 400);
      } else {
        this.createDt.changeSelectMode('Range');
        setTimeout(() => {
          this.createDt.changeShowDate([createStart, new Date(event.data.createEndDt)]);
        }, 400);
      }
    }

    if (!isNullOrEmpty(event.data.assignStartDate)) {
      const assignStartDate = new Date(event.data.assignStartDate);
      if (isNullOrEmpty(event.data.assignEndDate)) {
        this.assignDate.changeSelectMode('Start');
        setTimeout(() => {
          this.assignDate.changeShowDate(assignStartDate);
        }, 400);
      } else {
        this.assignDate.changeSelectMode('Range');
        setTimeout(() => {
          this.assignDate.changeShowDate([assignStartDate,new Date(event.data.assignEndDate),
          ]);
        }, 400);
      }
    }
  }

  optionsDataOnChange(data: any, type: string): void {
    switch (type) {
      case 'facilityList':
        this.searchParams.facilityList = data;
        break;
    }
  }

  frontlineDocBtnClick(): void {
    if (this.selectedBookings == null || this.selectedBookings == undefined || this.selectedBookings.length <= 0) {
      return;
    }
    this.frontLIneDocReferenceKeyList = [];
    const requests = this.selectedBookings.map(x =>
      this.bookingService.getDoList(x.bookingNo)
    );

    forkJoin(requests).subscribe({
      next: (results: any[][]) => {
        results.forEach(result => {
          this.frontLIneDocReferenceKeyList.push(...result);
        });
        this.isShowTaskDocManagement = true;
      },
      error: err => {
        console.error('Error fetching data:', err);
      }
    });
  }

  onShowFrontLineDoc(event: any) {
    this.frontlineDoc.resetComponent(this.frontLIneDocReferenceKeyList);
  }

}
